/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { Loader as a } from "@progress/kendo-react-indicators";
const n = {
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, o = (t) => {
  var r;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, t.showLoader ? (r = t.loader) != null ? r : /* @__PURE__ */ e.createElement("div", { className: "k-loading-mask" }, /* @__PURE__ */ e.createElement("div", { className: "k-loading-color" }), /* @__PURE__ */ e.createElement("div", { style: n }, /* @__PURE__ */ e.createElement(a, { size: "large", type: "converging-spinner" }))) : null);
};
export {
  o as GridLoader
};
